import { NgModule } from '@angular/core';
import { BoxComponent } from './box.component';

@NgModule({
  declarations: [BoxComponent],
  exports: [BoxComponent],
})
export class BoxModule {}
